import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getProfileDetails,
  updateProfileDetailsAction,
} from "../../../redux/actions/ProfileDetailsAction";
import { getCampaignsToken, getNetworkMenuId, getProviderPortalId, getRole } from "../../../Utils/types";
import WithGoogleApi from "../../../common/Map/WithGoogleApi";
import GmapsAddress from "../../../common/Map/GmapsAddress";
import Geocode from "react-geocode";
import {
  EditSaveHandler,
  isPageEditFalse,
} from "../CommonComponent/EditSaveHandler";
import { MandatoryStar } from "../../../Utils/helper";
import Datetime from "react-datetime";
import { Formik } from "formik";
import "react-datetime/css/react-datetime.css";
import {
  getCityNameAction,
  getStateNameAction,
  ViewRequestStatusAction,
} from "../../../redux/actions/GlobalAction";
import {
  InputTextFieldComponent,
  InputFieldComponent,
  InputFieldNumberComponent,
} from "../CommonComponent/InputFields";
import {
  formatToCapitalizedWords,
  isValidDate,
  YUPValidations,
} from "./helper";
import { callHomePageAPI } from "../CommonComponent/commonfunctionality";
import { addProviderAssitLogAction } from "../../../redux/actions/ProviderAssistAction";
import ROUTES from "../../../Utils/routesConstants";
import { useLocation } from "react-router-dom";

const ProfileDetails = () => {
  const dispatch = useDispatch();
  const location = useLocation()
  let source = location?.search.split("=")[1]
  Geocode.setApiKey("AIzaSyAy9gYbxqSCIe2BFo46GcNAk81zP-t7ZGA");
  const [data, setData] = useState({});
  const [streetAddr, setStreetAddr] = useState(null);
  const [currentLocationLatitute, setCurrentLocationLatitute] = useState(null);
  const [currentLocationLongitude, setCurrentLocationLongitude] =
    useState(null);
  const [isOpenLocationPopup, setIsOpenLocationPopup] = useState(false);

  const userProfileDetail = useSelector(
    (state) => state.ProfileDetailsReducer.getProfileDetails?.userProfileDetail
  );
  const isShowSubmitButton = useSelector(
    (state) => state.ProfileDetailsReducer.getProfileDetails?.isShowSubmitButton
  );
  const globalReducer = useSelector((state) => state.globalReducer);
  const isPageEdit = useSelector((state) => state?.globalReducer?.isPageEdit);

  useEffect(() => {
    dispatch(getProfileDetails());
    dispatch(getStateNameAction());
    navigator.geolocation.getCurrentPosition(function (position) {
      setCurrentLocationLatitute(position.coords.latitude);
      setCurrentLocationLongitude(position.coords.longitude);
    });
  }, []);

  useEffect(() => {
    if (userProfileDetail) {
      setData(userProfileDetail[0]);
    }
  }, [userProfileDetail]);

  useEffect(() => {
    if (data?.providerLatitude !== 0 || data?.providerLongitude !== 0) {
      Geocode.fromLatLng(data?.providerLatitude, data?.providerLongitude).then(
        (response) => {
          const address = response.results[0].formatted_address;
          setStreetAddr({
            caption: address,
            heart: {
              lat: data?.providerLatitude,
              lng: data?.providerLongitude,
            },
          });
        }
      );
    } else if (
      currentLocationLatitute !== null ||
      currentLocationLongitude !== null
    ) {
      Geocode.fromLatLng(
        currentLocationLatitute,
        currentLocationLongitude
      ).then((response) => {
        const address = response.results[0].formatted_address;
        setStreetAddr({
          caption: address,
          heart: {
            lat: currentLocationLatitute,
            lng: currentLocationLongitude,
          },
        });
      });
    }
  }, [data, currentLocationLatitute, currentLocationLongitude]);

  useEffect(() => {
    if (data.stateName) {
      const temp = globalReducer?.getAllState?.filter(
        (ele) => ele?.stateName === data?.stateName
      )?.[0]?.stateId;
      dispatch(getCityNameAction(temp));
    }
  }, [data?.stateName, globalReducer?.getAllState]);

  let inputProps = {
    placeholder: "Select Year",
    disabled: !isPageEdit,
    onKeyDown: (e) => {
      e.preventDefault();
    },
  };

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={{ ...data }}
        onSubmit={async (values) => {
          const temp = {
            ...values,
            providerId: +getProviderPortalId(),
            address2: values?.address1,
            address3: values?.address2,
          };
          await dispatch(updateProfileDetailsAction(source === "WhatsApp" || source === "Email"? {...temp,source:source}: getRole() === "NetworkAdmin" ? {...temp,source:"Network"} :temp));
          await dispatch(getProfileDetails());
          await dispatch(ViewRequestStatusAction("ProfileDetail"));
          await callHomePageAPI(dispatch);
          await isPageEditFalse(dispatch);
          window.location.pathname.includes(ROUTES.PROVIDER_ASSIST) &&
            (await dispatch(
              addProviderAssitLogAction({
                providerId: getProviderPortalId(),
                moduleName: "ProfileDetail",
                actionFlag: "E",
              })
            ));
        }}
        validationSchema={YUPValidations}
      >
        {(props) => {
          const { values, errors, handleChange, handleSubmit, setFieldValue } =
            props;
          return (
            <>
              <form onSubmit={handleSubmit}>
                <div className="profile-top-section">
                  <h4>Profile Details</h4>
                  {((getNetworkMenuId()?.canEdit && getRole() === "NetworkAdmin") || getRole() === "ServiceProvider" ||  getCampaignsToken() !== undefined)  &&
                    <EditSaveHandler
                      values={values}
                      userProfileDetail={userProfileDetail}
                      isShowViewButton={isShowSubmitButton}
                      moduleName="ProfileDetail"
                    />}
                </div>
                <div className="center-type">
                  <div className="row gy-5 mb-4">
                    <div className="col-md-4 col-12">
                      <h2>
                        Name of Centre <MandatoryStar />
                      </h2>
                      <input
                        name="providerName"
                        type="text"
                        placeholder="Enter provider name"
                        className="form-control"
                        value={values.providerName}
                        onChange={handleChange}
                        disabled={!isPageEdit}
                      />
                      {errors.providerName && isPageEdit && (
                        <div className="errorInputMessage">
                          {errors.providerName}
                        </div>
                      )}
                    </div>
                    <div className="col-md-4 col-12">
                      <h2>
                        Display Name&nbsp;
                        <span style={{ fontSize: "14px", fontWeight: "500" }}>
                          (Shown on App)
                        </span>
                        {/* <MandatoryStar /> */}
                      </h2>
                      <input
                        name="displayProviderName"
                        type="text"
                        placeholder="Enter display name"
                        className="form-control"
                        value={values.displayProviderName}
                        onChange={handleChange}
                        onBlur={() =>
                          setFieldValue(
                            "displayProviderName",
                            formatToCapitalizedWords(
                              values?.displayProviderName
                            )
                          )
                        }
                        disabled={!isPageEdit}
                      />
                      {errors.displayProviderName && isPageEdit && (
                        <div className="errorInputMessage">
                          {errors.displayProviderName}
                        </div>
                      )}
                    </div>
                    <div className="col-md-4 col-12">
                      <h2>
                        Area Name&nbsp;
                        <span style={{ fontSize: "14px", fontWeight: "500" }}>
                          (Shown on App)
                        </span>
                        {/* <MandatoryStar /> */}
                      </h2>
                      <input
                        name="areaName"
                        type="text"
                        placeholder="Enter area name"
                        className="form-control"
                        value={values.areaName}
                        onChange={handleChange}
                        onBlur={() =>
                          setFieldValue(
                            "areaName",
                            formatToCapitalizedWords(values?.areaName)
                          )
                        }
                        disabled={!isPageEdit}
                      />
                      {errors.areaName && isPageEdit && (
                        <div className="errorInputMessage">
                          {errors.areaName}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <h3 className="mt-2">
                        Centre Type
                        {/* <MandatoryStar /> */}
                      </h3>
                      <div style={{ marginTop: "18px" }}>
                        <div className="form-check form-check-inline">
                          <input
                            name="Diagnostic Center"
                            type="radio"
                            id="DC"
                            value={values.centerType}
                            onChange={(e) =>
                              isPageEdit &&
                              setFieldValue(
                                "centerType",
                                e.target.checked ? e.target.id : ""
                              )
                            }
                            checked={values?.centerType === "DC"}
                            className="form-check-input"
                          />
                          <label
                            htmlFor="DiagnosticCentre"
                            className="margin-right"
                          >
                            Diagnostic Centre
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            name="Hospitals"
                            type="radio"
                            id="HOSP"
                            value={values.centerType}
                            onChange={(e) =>
                              isPageEdit &&
                              setFieldValue(
                                "centerType",
                                e.target.checked ? e.target.id : ""
                              )
                            }
                            checked={values?.centerType === "HOSP"}
                            className="form-check-input"
                          />
                          <label htmlFor="Hospitals" className="margin-right">
                            Hospitals
                          </label>
                        </div>
                        {errors.centerType && isPageEdit && (
                          <div className="errorInputMessage">
                            {errors.centerType}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <h3 className=" mt-2">
                        Visit Type
                        {/* <MandatoryStar /> */}
                      </h3>
                      <div style={{ marginTop: "18px" }}>
                        <div className="form-check form-check-inline">
                          <input
                            name="Home Visit"
                            type="radio"
                            id="HV"
                            value={values?.visitSupport}
                            onChange={(e) =>
                              isPageEdit &&
                              setFieldValue(
                                "visitSupport",
                                e.target.checked ? e.target.id : ""
                              )
                            }
                            checked={values?.visitSupport === "HV"}
                            className="form-check-input"
                          />
                          <label htmlFor="HomeVisit" className="margin-right">
                            Home Visit
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            name="Centre Visit"
                            type="radio"
                            id="DC"
                            value={values.visitSupport}
                            onChange={(e) =>
                              isPageEdit &&
                              setFieldValue(
                                "visitSupport",
                                e.target.checked ? e.target.id : ""
                              )
                            }
                            checked={values?.visitSupport === "DC"}
                            className="form-check-input"
                          />
                          <label htmlFor="CenterVisit" className="margin-right">
                            Centre Visit
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            name="Mix Visit"
                            type="radio"
                            id="MIX"
                            value={values.visitSupport}
                            onChange={(e) =>
                              isPageEdit &&
                              setFieldValue(
                                "visitSupport",
                                e.target.checked ? e.target.id : ""
                              )
                            }
                            checked={values?.visitSupport === "MIX"}
                            className="form-check-input"
                          />
                          <label htmlFor="MixVisit" className="margin-right">
                            Mix Visit
                          </label>
                        </div>
                        {errors.visitSupport && isPageEdit && (
                          <div className="errorInputMessage">
                            {errors.visitSupport}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row gx-5 fill-details-section mt-5">
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-4">
                        <label className="form-label">Year Established</label>
                        {/* <MandatoryStar /> */}
                        <Datetime
                          dateFormat="YYYY"
                          timeFormat={false}
                          isValidDate={isValidDate}
                          value={values?.yearEstablish}
                          name="yearEstablish"
                          id="yearEstablish"
                          placeholder="Select Year of established"
                          onChange={(date) =>
                            setFieldValue("yearEstablish", date?.format("YYYY"))
                          }
                          inputProps={inputProps}
                        />
                        {errors.yearEstablish && isPageEdit && (
                          <div className="errorInputMessage">
                            {errors.yearEstablish}
                          </div>
                        )}
                      </div>
                    </div>
                    <InputTextFieldComponent
                      heading={"Authorized Person Name"}
                      placeholder="Enter authorized person name"
                      name={"authorizedPersonName"}
                      handleChange={handleChange}
                      isPageEdit={isPageEdit}
                      values={values.authorizedPersonName}
                      errors={errors.authorizedPersonName}
                      required={false}
                    />
                    <InputFieldNumberComponent
                      heading={"Registered Mobile Number"}
                      placeholder="Enter mobile number"
                      minLength={10}
                      maxLength={10}
                      name={"registeredMobileNo"}
                      handleChange={handleChange}
                      isPageEdit={isPageEdit}
                      values={values.registeredMobileNo}
                      errors={errors.registeredMobileNo}
                      required={false}
                    />
                    <InputFieldNumberComponent
                      heading={"Whatsapp Number"}
                      placeholder="Enter whatsapp number"
                      minLength={10}
                      maxLength={10}
                      name={"additionalMobileNo"}
                      handleChange={handleChange}
                      isPageEdit={isPageEdit}
                      values={values.additionalMobileNo}
                      errors={errors.additionalMobileNo}
                      required={false}
                    />
                    <InputFieldComponent
                      heading={"Registered Email Address"}
                      placeholder="Enter email address"
                      name={"registeredEmailID"}
                      handleChange={handleChange}
                      isPageEdit={isPageEdit}
                      values={values.registeredEmailID}
                      errors={errors.registeredEmailID}
                      required={false}
                    />
                    <InputFieldComponent
                      heading={"Official Website"}
                      name={"officialWebsite"}
                      handleChange={handleChange}
                      isPageEdit={isPageEdit}
                      values={values.officialWebsite}
                      errors={errors.officialWebsite}
                      required={false}
                    />
                    <InputFieldComponent
                      heading={"House Number"}
                      name={"houseNumber"}
                      handleChange={handleChange}
                      isPageEdit={isPageEdit}
                      values={values.houseNumber}
                      errors={errors.houseNumber}
                      required={false}
                    />
                    <InputFieldComponent
                      heading={"House Name"}
                      name={"houseName"}
                      handleChange={handleChange}
                      isPageEdit={isPageEdit}
                      values={values.houseName}
                      errors={errors.houseName}
                      required={false}
                    />
                    <InputFieldComponent
                      heading={"Address Line 1"}
                      name={"address1"}
                      handleChange={handleChange}
                      isPageEdit={isPageEdit}
                      values={values.address1}
                      errors={errors.address1}
                      required={false}
                    />
                    <InputFieldComponent
                      heading={"Address Line 2"}
                      name={"address2"}
                      handleChange={handleChange}
                      isPageEdit={isPageEdit}
                      values={values.address2}
                      errors={errors.address2}
                      required={false}
                    />
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-4">
                        <label className="form-label">State/Province</label>
                        {/* <MandatoryStar /> */}
                        <select
                          name="stateName"
                          value={values.stateName}
                          onChange={(e) => {
                            setFieldValue("stateName", e.target.value);
                            setData({
                              ...values,
                              stateName: e.target.value,
                              city: "",
                            });
                          }}
                          disabled={!isPageEdit}
                          className="form-select date-input"
                          style={{ marginTop: "10px" }}
                        >
                          <option value="">Select State</option>
                          {globalReducer?.getAllState?.map((ele) => {
                            return (
                              <option value={ele.stateName}>
                                {ele?.stateName}
                              </option>
                            );
                          })}
                        </select>
                        {errors.stateName && isPageEdit && (
                          <div className="errorInputMessage">
                            {errors.stateName}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-4">
                        <label className="form-label">City</label>
                        {/* <MandatoryStar /> */}
                        <select
                          name="city"
                          value={values.city}
                          onChange={(e) => {
                            setFieldValue("city", e.target.value);
                            setData({
                              ...values,
                              city: e.target.value,
                            });
                          }}
                          disabled={!isPageEdit}
                          className="form-select date-input"
                          style={{ marginTop: "10px" }}
                        >
                          <option value="">Select City</option>
                          {globalReducer?.getAllCity?.map((e) => {
                            return (
                              <option key={e.cityName} value={e.cityName}>
                                {e.cityName}
                              </option>
                            );
                          })}
                        </select>
                        {errors.city && isPageEdit && (
                          <div className="errorInputMessage">{errors.city}</div>
                        )}
                      </div>
                    </div>
                    <InputFieldNumberComponent
                      heading={"Pincode"}
                      name={"pincode"}
                      minLength={6}
                      maxLength={6}
                      handleChange={handleChange}
                      isPageEdit={isPageEdit}
                      values={values.pincode}
                      errors={errors.pincode}
                      required={false}
                    />
                    <InputFieldComponent
                      heading={"Landmark"}
                      name={"landmark"}
                      handleChange={handleChange}
                      isPageEdit={isPageEdit}
                      values={values.landmark}
                      errors={errors.landmark}
                      required={false}
                    />
                    <InputFieldComponent
                      heading={"Google My Business Link"}
                      name={"googleMyBusinessLink"}
                      handleChange={handleChange}
                      isPageEdit={isPageEdit}
                      values={values.googleMyBusinessLink}
                      errors={errors.googleMyBusinessLink}
                      required={false}
                    />
                    <InputFieldComponent
                      heading={"Practo Link"}
                      name={"practoLink"}
                      handleChange={handleChange}
                      isPageEdit={isPageEdit}
                      values={values.practoLink}
                      errors={errors.practoLink}
                      required={false}
                    />
                    <InputFieldComponent
                      heading={"BajajFinserv Link"}
                      name={"bajajFinservLink"}
                      handleChange={handleChange}
                      isPageEdit={isPageEdit}
                      values={values.bajajFinservLink}
                      errors={errors.bajajFinservLink}
                      required={false}
                    />
                    <InputFieldComponent
                      heading={"GetVisit Link"}
                      name={"getVisitLink"}
                      handleChange={handleChange}
                      isPageEdit={isPageEdit}
                      values={values.getVisitLink}
                      errors={errors.getVisitLink}
                      required={false}
                    />
                    <InputFieldComponent
                      heading={"EkaCare Link"}
                      name={"ekaCareLink"}
                      handleChange={handleChange}
                      isPageEdit={isPageEdit}
                      values={values.ekaCareLink}
                      errors={errors.ekaCareLink}
                      required={false}
                    />
                    <div className="col-lg-4 col-md-6">
                      <div className="mb-4">
                        <label className="form-label">
                          Locate on Google Map
                        </label>
                        <p
                          className="current-location"
                          data-bs-toggle="modal"
                          data-bs-target="#current-location-popup"
                          onClick={() => setIsOpenLocationPopup(true)}
                          style={{ pointerEvents: !isPageEdit && "none" }}
                        >
                          <span className="current-location-text">
                            Location on Google map
                          </span>
                          <span>
                            <img
                              src="https://live.healthassure.in/ProvidersPortal/images/locationicon.png"
                              alt="location icon"
                            />
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              {/* <!-- Map Popup --> */}
              <div
                className="modal fade"
                id="current-location-popup"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabIndex="-1"
                aria-labelledby="staticBackdropLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Locate on Google Map</h5>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={() => setIsOpenLocationPopup(false)}
                      ></button>
                    </div>
                    {isOpenLocationPopup && (
                      <>
                        <div className="modal-body">
                          <div className="row mb-4 align-items-end">
                            <label className="form-label mt-4">Search</label>
                          </div>
                          <div>
                            <WithGoogleApi>
                              <GmapsAddress
                                value={streetAddr}
                                onChange={setStreetAddr}
                              />
                            </WithGoogleApi>
                          </div>
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            className="btn btn-edit-outline"
                            data-bs-dismiss="modal"
                            onClick={() => setIsOpenLocationPopup(false)}
                          >
                            Cancel
                          </button>
                          {values.displayProviderName === ""}
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() =>
                              setData({
                                ...values,
                                providerLatitude:
                                  globalReducer?.getLocation?.providerLatitude,
                                providerLongitude:
                                  globalReducer?.getLocation?.providerLongitude,
                              })
                            }
                            data-bs-dismiss="modal"
                          >
                            Save Details
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </>
          );
        }}
      </Formik>
     
    </>
  );
};

export default ProfileDetails;
